<template>
  <div>
    <div class="col-xs-6 col-md-4 p-l-0">
      <div class="checkbox m-t-5 m-b-5">
        <label>
          <input
            ref="checkbox"
            :value="languageKey"
            :checked="level !== ''"
            name="languages"
            type="checkbox"
            @change="handleSelectionChanged"
          />
          <i class="input-helper" />
          &nbsp;
          <strong class="">{{ text }}</strong>
        </label>
      </div>
    </div>
    <div v-show="level !== ''">
      <div v-for="(option, key) in radioOptions" :key="key">
        <div class="col-xs-3 col-md-4 small p-l-0">
          <div class="radio m-t-5 m-b-5">
            <label>
              <input
                :checked="key === level"
                :name="`${languageKey}-level`"
                :value="key"
                type="radio"
                @change="handleRadioOptionChanged"
              />
              <i class="input-helper" />
              &nbsp;
              <span>{{ $t(option.textTranslationKey) }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checked: { type: Boolean, default: false },
    level: { type: String, default: '' },
    languageKey: { type: String, required: true },
    text: { type: [Number, String], required: true },
    radioOptions: { type: Object, required: true },
  },
  data() {
    return {
      selectedLevel: '',
    }
  },
  created() {
    this.selectedLevel = this.level
  },
  methods: {
    handleSelectionChanged(e) {
      const checkedStatus = e.target.checked
      // Add a default radio selection when checking a box
      if (checkedStatus && this.selectedLevel === '') {
        const [lastOptionAvailable] = Object.keys(this.radioOptions).slice(-1)
        this.selectedLevel = lastOptionAvailable
      }
      this.emitNewSelectionState()
    },
    handleRadioOptionChanged(e) {
      this.selectedLevel = e.target.value
      this.emitNewSelectionState()
    },
    emitNewSelectionState() {
      this.$emit('selection-updated', {
        languageKey: this.languageKey,
        checked: this.$refs.checkbox.checked,
        level: this.selectedLevel,
      })
    },
  },
}
</script>
